export default __webpack_public_path__ + "static/media/Subordinate Professional Activity.4d3a870c.jpg";